import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import crmservices from '../../wsclient';
import VerificationView from "./VerificationView";
import { config_path } from "../../router/config.path";
import { httpBackOfficeUtil } from "../../wsclient/crmservices/httpBackOfficeUtil";

export default function VerificationController(props) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [showProcessing, setShowProcessing] = useState(false);
    const [message, setMessage] = useState(null);
    const [method, setMethod] = useState('TOTP')

    const onVerify = async (data) => {
        setShowProcessing(true);
        console.log("AAAA onVerify data: ", data)
        try {
            let code = data.code;
            let accessToken = httpBackOfficeUtil.getSessionForVerify();
            let result = await crmservices.authentication.authenticate({
                "provider": "TWO_FACTOR",
                "two_factor_method": {
                    "method": method,
                    "value": code
                }
            }, accessToken);
            console.log("AAAA Verify result: ", result)
            if (result.code == "OK") {
                navigate(config_path.home);
            } else if (result.code == 'TOO_MANY_REQUESTS') {
                showMessage({ status: true, message: t('TOO_MANY_REQUESTS') });
            } else {
                showMessage({ status: true, message: t('INVALID_OTP') });
            }
        } catch (error) {
            console.log("AAAA onSubmit exception: ", error)
            showMessage({ status: true, message: t('EXCEPTION_PROCESS') });
        }
        setShowProcessing(false);
    }

    const showMessage = ({ status, title, message, otherMessage, callBackFn }) => {
        setShowProcessing(false);
        setMessage({ show: status, title: title, content: message, otherMessage, callBackFn: callBackFn ? callBackFn : () => setMessage({}) });
    }




    return (
        <VerificationView
            method={method}
            message={message}
            showProcessing={showProcessing}
            setMethod={setMethod}
            onSubmit={onVerify}
            onCancelVerify={props.setShowVerify}
        />
    )
}